import Repository from "./repository"

export default {
  post(params) {
    return Repository.post("api/create-sql/get", params)
  },
}